
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Breadcrumb,
  BreadcrumbService,
} from '../../../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  private breadcrumbService = inject(BreadcrumbService);
  private router = inject(Router);

  breadcrumbs: Breadcrumb[] = [];
  hasUnresolvedPlaceholders = false;
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.breadcrumbService
      .getBreadcrumbs()
      .pipe(takeUntil(this.destroy$))
      .subscribe((crumbs) => {
        this.breadcrumbs = crumbs;
        this.hasUnresolvedPlaceholders = crumbs.some((c) =>
          c.label.startsWith(':'),
        );
      });
  }

  navigateTo(index: number): void {
    const crumb = this.breadcrumbs[index];
    if (!crumb?.url) return;
    const trail = this.breadcrumbs.slice(0, index + 1);
    this.router.navigate([crumb.url], {
      state: {
        breadcrumbOverride: trail,
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
